import React from 'react'

import { NotificationModal } from '@masfront/common-b2c'

import useModal from '../hooks/useModal'

export default function SalesModal() {
  const {
    modal: { open, type, title, description, actions, onOpen },
    onCloseModal,
  } = useModal()

  return (
    <NotificationModal
      type={type}
      open={open}
      title={title}
      description={description}
      actions={actions}
      onOpen={onOpen}
      onClose={onCloseModal}
    />
  )
}
